import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import "./TimeRangePicker.scss"
import { DateHelper } from '@swivl-mono/helpers';
import { SliderRail, Handle, Track, Tick } from '../SliderComponents/SliderComponents'


interface TimeRangePickerProps {
  start: number;
  end: number;
  name: string;
  onChange: (event: any) => void;
}
interface State {
  start: number;
  end: number;
}
export class TimeRangePicker extends React.Component<TimeRangePickerProps, State> {
  constructor(props: TimeRangePickerProps) {
    super(props)
    this.state = { start: props.start, end: props.end }
    this.onUpdate = this.onUpdate.bind(this)
    this.onChange = this.onChange.bind(this)

  }
  onUpdate(e) {
    this.setState({ start: e[0], end: e[1] })
  }
  onChange(e) {
    this.props.onChange({ target: { name: this.props.name, value: { start: e[0], end: e[1] } } })
    this.setState({ start: e[0], end: e[1] })
  }
  render() {
    const sliderStyle = {
      position: "relative",
      width: "100%"
    };
    const start = this.props.start;
    const end = this.props.end;

    // var startPeriod, endPeriod;
    //
    // var startMinutes = start % 60;
    // if (startMinutes ==  0) { startMinutes  = "00" }
    // var startHours = (start - startMinutes) / 60;
    // if (startHours > 12) {
    //   startHours -= 12;
    //   startPeriod = "PM"
    // } else if (startHours == 12) {
    //   startPeriod = "PM"
    // } else  {
    //   startPeriod = "AM"
    // }
    //
    //
    //
    // if (startHours == 0) {
    //   startHours = 12;
    // }
    // var endMinutes = end % 60;
    // if (endMinutes ==  0) { endMinutes  = "00" }
    // var endHours = (end - endMinutes) / 60;
    // if (endHours > 12) {
    //   endHours -= 12;
    //   endPeriod = "PM"
    // } else {
    //   endPeriod = "AM"
    // }

    const domain = [0, 1439];
    const defaultValues = [start, end];


    return <div className={"SSTimeRangePicker"}>
      <div className="label"><small>Between</small><br /><span>{DateHelper.minutesToTime(this.state.start)}</span> & <span>{DateHelper.minutesToTime(this.state.end)}</span></div>
      <div className="sliderWrapper">
        <Slider
          mode={3}
          step={15}
          domain={domain}
          rootStyle={sliderStyle}
          onUpdate={this.onUpdate}
          onChange={this.onChange}
          values={defaultValues}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>

        </Slider>
      </div>

    </div>;
  }
};

// SSTimeRangePicker.propTypes = {
//   name: PropTypes.string,
//   checked:  PropTypes.bool,
// };
